import React from 'react';
import { Check, Loader2 } from 'lucide-react';

const STEPS = [
  { key: 'send', label: 'Send' },
  { key: 'confirm', label: 'Confirm' },
  { key: 'exchange', label: 'Exchange' },
  { key: 'done', label: 'Complete' },
];

/**
 * activeIndex: which step (0-3) is currently in progress.
 * complete: true once the whole swap is finished (all steps marked done).
 * Not rendered for failed/refunded/expired orders — those get their own
 * dedicated message instead of a partially-filled progress bar.
 */
const ThawMeter = ({ activeIndex = 0, complete = false }) => {
  const fillPct = complete ? 100 : (activeIndex / (STEPS.length - 1)) * 100;

  return (
    <div className="thaw-meter">
      <div className="thaw-track">
        <div className="thaw-line">
          <div className="thaw-line-fill" style={{ width: `${fillPct}%` }} />
        </div>
        {STEPS.map((step, i) => {
          const done = complete || i < activeIndex;
          const current = !complete && i === activeIndex;
          const cls = done ? 'done' : current ? 'current' : '';
          return (
            <div key={step.key} className={`thaw-node ${cls}`}>
              <div className="thaw-dot">
                {done ? <Check size={16} /> : current ? <Loader2 size={15} /> : <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor' }} />}
              </div>
              <span className="thaw-label">{step.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThawMeter;
